import 'react';
import { TransitionGroup } from 'react-transition-group';
import { pm2SitemapStore } from '@pm2/sitemap-utils';
import { selectIsFavouritesEnabled, useToggleFavouriteMutation } from '@pm2/user-area';
import { useTrackingManager } from '@provider/tracking';
import { useUserIdentityState } from '@provider/user-identity';
import { breakpoints } from '@ui/css';
import { Tooltip, Pill } from '@ui/kit';
import { HeartIcon } from '@ui/kit/icons';
import { CSSRefTransition, useMatchBreakpoint } from '@utils/react';
import { container, fadeDurationMs, button, icon } from './atom.favourite-button.style.js';
import { jsx } from 'react/jsx-runtime';

function FavouriteButton(props) {
  const isLoggedIn = useUserIdentityState(state => !!state.user);
  const isEnabled = pm2SitemapStore.useSelector(selectIsFavouritesEnabled);
  const descriptor = (() => {
    switch (props.descriptor?.type) {
      case "Course":
        return {
          type: "course",
          version: "1",
          courseId: props.descriptor.id
        };
      case "Page":
        return {
          type: "page",
          version: "1",
          pageId: props.descriptor?.id
        };
    }
  })();
  if (!isLoggedIn || !isEnabled) {
    return null;
  }
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: !props.descriptor?.clientside && !!descriptor && /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: fadeDurationMs,
      classNames: container,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: container,
        children: /*#__PURE__*/jsx(Content, {
          descriptor: descriptor,
          pageDescriptor: props.descriptor
        })
      })
    })
  });
}
function Content(props) {
  const tracker = useTrackingManager();
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const {
    addMutation,
    deleteMutation,
    isFavourite
  } = useToggleFavouriteMutation(props.descriptor);
  const handleToggle = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    if (addMutation.isPending || deleteMutation.isPending) {
      return;
    }
    const trackingContext = {
      context: "page",
      targetId: props.pageDescriptor?.id ?? "",
      targetPath: props.pageDescriptor?.path ?? "",
      targetTitle: props.pageDescriptor?.title ?? "",
      targetType: props.pageDescriptor?.type ?? "Page"
    };
    if (isFavourite) {
      deleteMutation.mutate();
      tracker.trackEvent("userarea.favourites.delete", trackingContext);
    } else {
      addMutation.mutate();
      tracker.trackEvent("userarea.favourites.add", trackingContext);
    }
  };
  return /*#__PURE__*/jsx(Tooltip, {
    ariaType: "label",
    placement: "bottom",
    body: isFavourite ? "Fjern fra favoritter" : "Tilføj til favoritter",
    children: ref => /*#__PURE__*/jsx(Pill, {
      className: button,
      ref: ref,
      onClick: handleToggle,
      active: isFavourite,
      size: "compact",
      activeTheme: "accent",
      icon: /*#__PURE__*/jsx(HeartIcon, {
        className: icon,
        "data-favourite": isFavourite
      }),
      children: !isMobile && /*#__PURE__*/jsx("span", {
        children: "Favorit"
      })
    })
  });
}

export { FavouriteButton };
//# sourceMappingURL=atom.favourite-button.js.map
